import React, { PropsWithChildren } from 'react'
import { AnalyticsElement } from '@typesApp/Analytics'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { IconAnchor } from '@components/foundation/icon-anchor/IconAnchor'
import { injectAnalytics } from '@utils/analyticsAttributes'
import { injectDataAttributes } from '@utils/dataAttributes'
import styles from '../styles/ContactUsPanel.module.scss'

type ActionProps = {
  analyticsIndex: number
  noIcon?: boolean
  noPreLink?: boolean
} & PropsWithChildren

export const EmailAction: React.FC<ActionProps> = ({ analyticsIndex, noIcon, noPreLink, children }) => {
  const { t } = useAppTranslation()

  return (
    <IconAnchor
      href={`mailto:${t('ContactInfo.email')}`}
      underline
      iconProps={noIcon ? undefined : { library: 'base', name: 'email' }}
      preLink={noPreLink ? undefined : t('ContactInfo.email-prelink')}
      preLinkClassName={noPreLink ? undefined : styles.preLink}
      {...injectDataAttributes('contactUs.email')}
      {...injectAnalytics(AnalyticsElement.MORE_INFO, { index: analyticsIndex })}
    >
      {!children && <span className={styles.linkText}>{t('ContactInfo.email')}</span>}
      {children}
    </IconAnchor>
  )
}
